import _ from 'lodash'
import Mustache from 'mustache'
import { formatNumber } from 'core/service/lib/number-format'
import MESSAGES from 'core/data-model/constants/bi-messages'

const rowHeightConfig = { lineHeight: 0.75, margin: [0, 0, 0, 0] }

const buildHeaderGlobalIndexInvestmentBenefitTable = () => {
  return [
    [
      { text: MESSAGES.INVESTMENT_BENEFITS_SUMMARY, style: 'tableHeader', margin: [0, 40] },
      {
        text:
          MESSAGES.EXAMPLE_1 +
          '\n' +
          MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_2 +
          '\n' +
          MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_3 +
          ' ' +
          MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_LOW,
        // style: 'tableHeader',
        style: {
          alignment: 'center',
          bold: true,
          noWarp: true,
          fontSize: 11,
        },
        margin: [0, 25],
      },
      {
        text:
          MESSAGES.EXAMPLE_2 +
          '\n' +
          MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_2 +
          '\n' +
          MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_3 +
          ' ' +
          MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_MIDDLE,
        // style: 'tableHeader',
        style: {
          alignment: 'center',
          bold: true,
          noWarp: true,
          fontSize: 11,
        },
        margin: [0, 25],
      },
      {
        text:
          MESSAGES.EXAMPLE_3 +
          '\n' +
          MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_2 +
          '\n' +
          MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_3 +
          ' ' +
          MESSAGES.GLOBAL_INDEX_16_6_BENEFITS_SCENARIO_HIGH,
        // style: 'tableHeader',
        style: {
          alignment: 'center',
          bold: true,
          noWarp: true,
          fontSize: 11,
        },
        margin: [0, 25],
      },
    ],
  ]
}

const buildInvestmentBenefitRowGuarantee = (investmentBenefit, isBold = false) => [
  {
    text: investmentBenefit.title,
    alignment: 'left',
    bold: isBold,
    // ...rowHeightConfig,
  },
  ...investmentBenefit.rates.map((r) => {
    return {
      text: formatNumber(r, 0, true),
      alignment: 'right',
      bold: isBold,
      // ...rowHeightConfig,
    }
  }),
]

const buildInvestmentBenefitRowNonGuarantee = (investmentBenefit, isBold = false) => [
  {
    text: investmentBenefit.title,
    alignment: 'left',
    bold: isBold,
    // ...rowHeightConfig,
  },
  ...investmentBenefit.rates.map((r) => {
    return {
      text: formatNumber(r, 0, true),
      alignment: 'right',
      bold: isBold,
      // ...rowHeightConfig,
    }
  }),
]

const buildDisclaimer = () => [
  {
    stack: [`${MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.TITLE}`],
    style: { fontSize: 12, bold: true },
    pageBreak: '',
  },
  {
    stack: [`- ${MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_1}`],
    style: { fontSize: 9 },
  },
  {
    stack: [`- ${MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_2}`],
    style: { fontSize: 9 },
  },
  {
    stack: [`- ${MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.REMARK.BULLET_3}`],
    style: { fontSize: 9 },
  },
  { text: ' ' },
  {
    stack: [`${MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.TITLE}`],
    style: { fontSize: 12, bold: true },
  },
  {
    stack: [`- ${MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_1}`],
    style: { fontSize: 9 },
  },
  {
    stack: [`- ${MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_2}`],
    style: { fontSize: 9 },
  },
  {
    stack: [`- ${MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_3}`],
    style: { fontSize: 9 },
  },
  {
    stack: [`- ${MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_4}`],
    style: { fontSize: 9 },
  },
  {
    stack: [`- ${MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_5}`],
    style: { fontSize: 9 },
  },
  {
    stack: [`- ${MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_6}`],
    style: { fontSize: 9 },
  },
  {
    stack: [
      `1) ${MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_6_1}`,
    ],
    margin: [15, 0, 0, 0],
    style: { fontSize: 9 },
  },
  {
    stack: [
      `2) ${MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_6_2}`,
    ],
    margin: [15, 0, 0, 0],
    style: { fontSize: 9 },
  },
  {
    stack: [`${MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_6_3}`],
    style: { fontSize: 9 },
  },
  {
    stack: [`- ${MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_1.IMPORTANT_INSTRUMENTS_INVESTED.BULLET_7}`],
    style: { fontSize: 9 },
  },
]

export const buildGlobalIndexBenefitSummaryTable_1 = (investmentBenefit) => [
  {
    table: {
      headerRows: 1,
      widths: [200, 'auto', 'auto', 'auto'],
      body: [
        ...buildHeaderGlobalIndexInvestmentBenefitTable(),
        ...investmentBenefit.guaranteeBenefits.map((r, k) =>
          investmentBenefit.guaranteeBenefits.length - 1 === k
            ? buildInvestmentBenefitRowGuarantee(r, true)
            : buildInvestmentBenefitRowGuarantee(r)
        ),
        ...investmentBenefit.nonGuaranteeBenefits.map((r, k) =>
          investmentBenefit.nonGuaranteeBenefits.length - 1 === k
            ? buildInvestmentBenefitRowNonGuarantee(r, true)
            : buildInvestmentBenefitRowNonGuarantee(r)
        ),
      ],
    },
    layout: 'investmentBenefitTableUniversalLinkStyle',
    style: 'table',
  },
]

const buildHeaderBenefitSummaryTable_2 = () => {
  return [
    [
      { text: MESSAGES.INVESTMENT_BENEFITS_SUMMARY, style: 'tableHeader', margin: [0, 30] },
      { text: MESSAGES.INVESTMENT_BENEFITS_GUARANTEE, style: 'tableHeader', margin: [0, 30] },
    ],
  ]
}

const buildDetailBenefitSummaryTable_2 = (investmentBenefit) => {
  const benefitSummaryUniversalLink = investmentBenefit.benefitSummaryUniversalLink
  return [
    [
      {
        text: Mustache.render(MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_2[0].description, {
          description: MESSAGES.GLOBAL_INDEX_16_6_DEATH_BENEFIT_MINIMUM_TITLE,
        }),
        alignment: 'left',
        bold: true,
        // ...rowHeightConfig,
      },
      {
        text: Mustache.render(MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_2[0].benefit, {
          value: formatNumber(benefitSummaryUniversalLink[0].value, 0, true),
        }),
        alignment: 'right',
        // ...rowHeightConfig,
      },
    ],
    [
      {
        text: MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_2[1].description,
        alignment: 'left',
        bold: true,
        // ...rowHeightConfig,
      },
      {
        text: MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_2[1].benefit,
        alignment: 'right',
        // ...rowHeightConfig,
      },
    ],
    [
      {
        text: Mustache.render(MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_2[2].description, {
          description: MESSAGES.GLOBAL_INDEX_16_6_BENEFIT_CASH_DROP_TWO_PERCENT,
        }),
        alignment: 'left',
        margin: [5, 0, 0, 0],
        // ...rowHeightConfig,
      },
      {
        text: Mustache.render(MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_2[2].benefit, {
          value: formatNumber(benefitSummaryUniversalLink[2].value, 0, true),
        }),
        alignment: 'right',
        // ...rowHeightConfig,
      },
    ],
    [
      {
        text: Mustache.render(MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_2[3].description, {
          description: MESSAGES.GLOBAL_INDEX_16_6_BENEFIT_CASH_DROP_SIX_PERCENT,
        }),
        alignment: 'left',
        margin: [5, 0, 0, 0],
        // ...rowHeightConfig,
      },
      {
        text: Mustache.render(MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_2[3].benefit, {
          value: formatNumber(benefitSummaryUniversalLink[3].value, 0, true),
        }),
        alignment: 'right',
        // ...rowHeightConfig,
      },
    ],
    [
      {
        text: Mustache.render(MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_2[4].description, {
          description: MESSAGES.GLOBAL_INDEX_16_6_BENEFIT_CASH_DROP_MATURITY_TITLE,
        }),
        alignment: 'left',
        bold: true,
        // ...rowHeightConfig,
      },
      {
        text: Mustache.render(MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_2[4].benefit, {
          value: formatNumber(benefitSummaryUniversalLink[4].value, 0, true),
        }),
        alignment: 'right',
        // ...rowHeightConfig,
      },
    ],
    [
      {
        text: MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_2[5].description,
        alignment: 'left',
        bold: true,
        // ...rowHeightConfig,
      },
      {
        text: MESSAGES.GLOBAL_INDEX_16_6_MESSAGE.BENEFIT_SUMMARY_TABLE_2[5].benefit,
        alignment: 'left',
        fontSize: 9,
        // ...rowHeightConfig,
      },
    ],
  ]
}

export const buildGlobalIndexBenefitSummaryTable_2 = (investmentBenefit) => [
  {
    table: {
      headerRows: 1,
      widths: [190, '*'],
      body: [...buildHeaderBenefitSummaryTable_2(), ...buildDetailBenefitSummaryTable_2(investmentBenefit)],
    },
    layout: 'lightBorder',
    style: 'table',
  },
]

export const investmentBenefitTableGlobalIndexSection = ({ investmentBenefit }) => [
  { text: MESSAGES.INVESTMENT_BENEFITS, style: 'title', pageBreak: 'before' },
  buildGlobalIndexBenefitSummaryTable_1(investmentBenefit),
  buildDisclaimer(),
  { text: MESSAGES.INVESTMENT_BENEFITS, style: 'title' },
  buildGlobalIndexBenefitSummaryTable_2(investmentBenefit),
]
